import { render, staticRenderFns } from "./CalendarIndex.vue?vue&type=template&id=4b596602&scoped=true"
import script from "./CalendarIndex.vue?vue&type=script&lang=js"
export * from "./CalendarIndex.vue?vue&type=script&lang=js"
import style0 from "./CalendarIndex.vue?vue&type=style&index=0&id=4b596602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b596602",
  null
  
)

export default component.exports